import styles from "../../style.module.scss";
import useStore from "../../store/store";
import {useEffect, useState} from "react";
import Hint from "../ui/hint/hint";
import {formatLocationPriceLabel, getLocationServicePrice, sortLocationServices} from "../../utils/location-service";
import {getServiceDescription, getServiceName} from "../../utils/service-text";

function Step5({number, services}) {
    const [open, setOpen] = useState(false);
    const ratesHide = useStore((state) => state.ratesHide)
    const carReturnLocation = useStore((state) => state.carReturnLocation)
    const setCarReturnLocation = useStore((state) => state.setCarReturnLocation)
    const finishHours = useStore((state) => state.finishHours)
    const workTime = useStore((state) => state.workTime)
    const lang = useStore((state) => state.lang)
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setIsMobile(window.innerWidth <= 991);
    }, []);

    const t = {
        carReturnLocation: lang === 'en' ? 'Car return location' : 'Место возврата авто',
        inOffice: lang === 'en' ? 'In the office' : 'В офисе',
    };

    const getCurrentValue = () => {
        if (carReturnLocation) {
            const location = services.filter((service) => service.caraddonid === carReturnLocation);
            if (location && location[0]) {
                return getServiceName(location[0], lang);
            }
        }
        return t.inOffice;
    }
    if (!services) {
        return null;
    }

    const locationServices = sortLocationServices(services, isMobile);

    return (<div className={styles.newOrder__step}>
        <div className={`${styles.newOrder__stepHead} p-size`} onClick={() => setOpen(!open)}>
            <div className={styles.newOrder__stepNumber}>
                {ratesHide ? number - 1 : number}
            </div>
            {t.carReturnLocation}
            <div className={styles.newOrder__stepValue}>{getCurrentValue()}</div>
            <div className={`${styles.newOrder__stepStatus} ${open && styles.open}`}/>
        </div>
        {
            open && (
                <div className={styles.newOrder__stepContent}>
                    <div className={styles.locations}>
                        <div className={styles.location} onClick={() => setCarReturnLocation(null)}>
                            <div className={`${styles.checkbox} ${!carReturnLocation && styles.checked}`}/>
                            <span className='p-small-size'>{t.inOffice}</span>
                        </div>
                        {
                            locationServices.map((item) => {
                                if (item.caraddonsitegroup === 'Место возврата автомобиля') {
                                    const price = getLocationServicePrice(item, {
                                        isPickup: false,
                                        finishHours,
                                        workTime,
                                    });
                                    if (price > 0) {
                                        const serviceDescription = getServiceDescription(item, lang);

                                        return (<div key={item.caraddonid} className={styles.location}
                                                     onClick={() => setCarReturnLocation(item.caraddonid)}>
                                            <div
                                                className={`${styles.checkbox} ${carReturnLocation === item.caraddonid && styles.checked}`}/>
                                            <span className={`${styles.heading} p-small-size`}>
                                            {getServiceName(item, lang)}
                                                {formatLocationPriceLabel(item, price, lang)}
                                                {
                                                    !!serviceDescription && (
                                                        <Hint text={serviceDescription}/>)
                                                }
                                        </span>
                                        </div>)
                                    }
                                }
                                return null;
                            })
                        }
                    </div>
                </div>
            )
        }

    </div>);
}

export default Step5;
